// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"420":"45971c8e","561":"0446e33d","788":"b32804d6","830":"baa00cfb","981":"8d33d29c"}[chunkId] + ".chunk.css";
};